import { type ReactNode, useEffect } from "react";

import { useRouteModalsStore } from "./route-modals.store";

interface ModalPageProps {
  children?: ReactNode;
  fallbackPath: string;
}

export const ModalPage = ({ children, fallbackPath }: ModalPageProps) => {
  const setMounted = useRouteModalsStore((state) => state.setMounted);
  const setFallbackPath = useRouteModalsStore((state) => state.setFallbackPath);
  const setChildren = useRouteModalsStore((state) => state.setChildren);
  const clearState = useRouteModalsStore((state) => state.clearState);

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
      clearState();
    };
  }, [setMounted, clearState]);

  useEffect(() => {
    setFallbackPath(fallbackPath);
  }, [fallbackPath, setFallbackPath]);

  useEffect(() => {
    setChildren(children);
  }, [children, setChildren]);

  return null;
};
